{
  "fr": {
    "salesWizard": {
      "steps": {
        "contact": "Coordonnées",
        "license": "Sélection de licence",
        "workshops": "Ateliers",
        "school": "École"
      },
      "contactStep": {
        "headline": "Formulaire de contact pour les écoles",
        "description": "Veuillez entrer vos coordonnées pour que nous puissions vous envoyer toutes les informations nécessaires. Veuillez faire particulièrement attention à l'orthographe correcte de votre adresse e-mail.",
        "formOfAddress": "Civilité",
        "formOfAddressFemale": "Madame",
        "formOfAddressMale": "Monsieur",
        "firstname": "Prénom",
        "lastname": "Nom de famille",
        "email": "Adresse e-mail",
        "phone": "Téléphone"
      },
      "entry": {
        "loading": "Le formulaire de contact est en cours de préparation…",
        "error": "Le formulaire de contact n'a pas pu être lancé. Veuillez recharger la page ou réessayer plus tard."
      },
      "confirmation": {
        "headline": "Merci pour votre demande !",
        "offerSingle": "Vous recevrez bientôt une offre à l'adresse e-mail suivante :",
        "offerMultiple": "Vous recevrez bientôt plusieurs offres à l'adresse e-mail suivante :",
        "support": "Si vous avez des questions entre-temps, n'hésitez pas à contacter notre support à",
        "notFound": "Cette demande n'a pas été trouvée. Veuillez vérifier le lien ou démarrer une nouvelle demande."
      },
      "saveError": "Échec de l'enregistrement. Veuillez réessayer.",
      "choiceStep": {
        "headline": "Sélectionnez maintenant une ou plusieurs options de licence",
        "description": "Pour chaque pack de licences, vous recevrez une offre afin de pouvoir les comparer.",
        "numOfEmployees": "Taille du corps enseignant",
        "maxMembersCount": "Nombre de licences nécessaires",
        "package": "Choisissez le pack de licences qui vous convient",
        "packageLabels": {
          "package_s": "Licence S",
          "package_m": "Licence M",
          "package_l": "Licence L",
          "package_xl": "Licence XL"
        },
        "upto": "Jusqu'à",
        "people": "Personnes",
        "aboveLimit": {
          "headline": "Offre personnalisée pour plus de 120 personnes",
          "description": "Pour une offre de plus de 120 licences, nous vous conseillons volontiers personnellement. Veuillez nous appeler au",
          "or": "ou",
          "chooseAppointment": "prenez rendez-vous pour une consultation"
        },
        "bavaria": {
          "headline": "Informations importantes pour la Bavière concernant le budget médias et IA :",
          "intro": "Les packs de licences suivants peuvent être financés selon les directives de subvention et après accord avec l'Office régional bavarois pour l'école :",
          "items": {
            "allInclusive": "Licence scolaire tout compris (100% éligible)",
            "tools": "Licence scolaire outils (100% éligible)",
            "toTeach": "Licence scolaire to teach (100% éligible)",
            "combo": "Licence scolaire combinée (seulement partiellement éligible)"
          },
          "moreInfo": "Vous trouverez ici plus d'informations et un lien de consultation :"
        },
        "subHeadlineCombined": "Profitez de nos packs combinés",
        "subHeadlineProduct": "Ou sélectionnez ici des produits individuels",
        "popular": "Populaire",
        "year": "An",
        "licenceItemsEmpty": "Au moins un type de licence doit être sélectionné.",
        "configLoadError": "Les options de licence n'ont pas pu être chargées.",
        "itemsLoadError": "Les packages de licence n'ont pas pu être chargés."
      },
      "workshopStep": {
        "headline": "Ateliers numériques",
        "description": "Recommandation : un atelier annuel pour l'équipe enseignante est idéal pour une utilisation réussie de fobizz et une plus grande satisfaction.",
        "itemTypes": {
          "workshop": "Atelier pratique",
          "presentation": "Conférence d'impulsion",
          "consulting": "conseil individuel"
        },
        "durationMinutes": "{duration} minutes",
        "details": "Détails de l'atelier",
        "configLoadError": "Les options d'atelier n'ont pas pu être chargées.",
        "incompleteRequest": "La demande n'a pas pu être envoyée car les étapes précédentes sont incomplètes. Veuillez revenir en arrière et compléter vos informations."
      },
      "schoolStep": {
        "headline": "Formulaire de contact pour les écoles",
        "description": "Sélectionnez votre école ici :",
        "searchHint": "Vous pouvez rechercher par code postal ou par nom d'école.",
        "notFoundHint": "Si vous ne trouvez pas votre école, veuillez cocher la case ci-dessous et saisir les informations vous-même.",
        "searchLabel": "École",
        "searchPlaceholder": "Rechercher une école…",
        "searchFieldHint": "Astuce : vous pouvez rechercher par code postal ou par nom d'école",
        "noResults": "Aucune école trouvée.",
        "initialRequest": "Mon école n'est pas répertoriée",
        "companyName": "Nom de l'établissement",
        "street": "Rue et numéro",
        "zipcode": "Code postal",
        "city": "Ville",
        "countryCode": "Pays",
        "kind": "Établissement d'enseignement",
        "schoolType": "Type d'école",
        "schoolTypeCustom": "Autre type d'école",
        "baseError": "Sélectionnez une école ou cochez « Mon école n'est pas répertoriée » et saisissez les informations vous-même"
      },
      "taxInfo": "Tous les prix incl. TVA {rate} % (ou le taux de TVA en vigueur)",
      "retry": "Réessayer",
      "back": "Retour"
    }
  }
}
